import React from "react";
import { motion } from "framer-motion";

const animations = {
  initial: { opacity: 0, scale: 0.99 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, transition: { duration: 0 } }, // Instant exit to reduce wait time
};

const PageTransition = ({ children }) => {
  return (
    <motion.div
      variants={animations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2 }} // Smooth entry
      className="w-full"
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
